<script setup lang="ts">
const localePath = useLocalePath();

interface NavLink {
  name: string
  link: string
}

defineProps({
  title: String,
  description: String,
  links: Array<NavLink>,
  current: String
})

</script>

<template>
  <!-- Page Title -->
  <div class="page-title dark-background">
    <div class="heading">
      <div class="container">
        <div class="row d-flex justify-content-center text-center">
          <div class="col-lg-8">
            <h1>{{ title }}</h1>
            <p class="mb-0">{{ description }}</p>
          </div>
        </div>
      </div>
    </div>
    <nav class="breadcrumbs">
      <div class="container">
        <ol>
          <li v-for="item in links" :key="item.link">
            <NuxtLink :to="localePath(item.link)">{{ item.name }}</NuxtLink>
          </li>
          <li class="current">{{ current }}</li>
        </ol>
      </div>
    </nav>
  </div><!-- End Page Title -->

</template>

<style scoped>
a {
  color: var(--accent-color);
}

a:hover {
  color: color-mix(in srgb, var(--accent-color), transparent 25%);
  text-decoration: none;
}

/*--------------------------------------------------------------
# Global Page Titles & Breadcrumbs
--------------------------------------------------------------*/
.page-title {
  color: var(--default-color);
  background-color: var(--background-color);
  position: relative;
}

.page-title .heading {
  padding: 100px 0 20px 0;
  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
}

.page-title .heading h1 {
  font-size: 38px;
  font-weight: 700;
}

.page-title nav {
  background-color: color-mix(in srgb, var(--default-color), transparent 95%);
  padding: 20px 0;
}

.page-title nav ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.page-title nav ol li + li {
  padding-left: 10px;
}

.page-title nav ol li + li::before {
  content: "/";
  display: inline-block;
  padding-right: 10px;
  color: color-mix(in srgb, var(--default-color), transparent 70%);
}

@media (max-width: 767px) {
  .page-title .heading {
    padding: 75px 0 20px 0;
  }
  .page-title .heading h1 {
    font-size: 30px;
    font-weight: 700;
  }

  .page-title nav {
    padding: 5px 0;
  }

  .page-title li,
  .page-title p {
    font-size: 14px;
  }

}
</style>